const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY

export const geocodeSuburb = async (
  suburb: string
): Promise<{ lat: number; lng: number }> => {
  let response: Response

  try {
    response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
        suburb
      )}&key=${apiKey}`
    )
  } catch {
    throw new Error('Failed to geocode suburb')
  }

  if (!response.ok) {
    throw new Error('Failed to geocode suburb')
  }

  const data = await response.json()

  if (!data.results || data.results.length === 0) {
    throw new Error('No results found for the provided suburb')
  }

  const { lat, lng } = data.results[0].geometry.location
  return { lat, lng }
}

export const getBrowserLocation = (): Promise<{ lat: number; lng: number }> => {
  if (!navigator.geolocation) {
    return Promise.reject(
      new Error('Geolocation is not supported by this browser')
    )
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      position => {
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        })
      },
      error => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            reject(new Error('Geolocation permission denied'))
            break
          case error.POSITION_UNAVAILABLE:
            reject(new Error('Position unavailable'))
            break
          case error.TIMEOUT:
            reject(new Error('Geolocation request timed out'))
            break
          default:
            reject(new Error('Geolocation request timed out'))
        }
      }
    )
  })
}
